(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4454],{

/***/ 50659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _JSX__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(706);
/* harmony import */ var _mosanic_fields_Button_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47914);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41145);
/* harmony import */ var _mosanic_items__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51085);
/* harmony import */ var _redux_modal_action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39623);
/* harmony import */ var _redux_modal_reducer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18891);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64157);







var BuilderConfirm = function() {
    var modal = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_modal_reducer__WEBPACK_IMPORTED_MODULE_2__/* .getModalSelector */ .SY);
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var close = function() {
        return dispatch(_redux_modal_action__WEBPACK_IMPORTED_MODULE_3__/* .closeModal */ .Mr);
    };
    var confirm = function() {
        return dispatch((0,_redux_modal_action__WEBPACK_IMPORTED_MODULE_3__/* .confirmModalAction */ .FK)());
    };
    var decline = function() {
        return dispatch((0,_redux_modal_action__WEBPACK_IMPORTED_MODULE_3__/* .declineModalAction */ .Nb)());
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_items__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        state: Boolean(modal === null || modal === void 0 ? void 0 : modal.message),
        close: close,
        size: "xs",
        fullWidth: modal === null || modal === void 0 ? void 0 : modal.fullWidth,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_JSX__WEBPACK_IMPORTED_MODULE_5__.If, {
                condition: modal === null || modal === void 0 ? void 0 : modal.title,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    children: modal.title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_items__WEBPACK_IMPORTED_MODULE_6__/* .AdvancedLabel */ .qv, {
                size: "large",
                children: modal.message
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mosanic_fields_Button_Buttons__WEBPACK_IMPORTED_MODULE_7__.Buttons, {
                mt: 4,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields_Button_Buttons__WEBPACK_IMPORTED_MODULE_7__.Button, {
                        handler: confirm,
                        children: "Confirm"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_fields_Button_Buttons__WEBPACK_IMPORTED_MODULE_7__.Button, {
                        handler: decline,
                        variant: "decline",
                        children: "Decline"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BuilderConfirm);


/***/ }),

/***/ 34454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BuilderConfirm": function() { return /* reexport */ BuilderConfirm/* default */.Z; },
  "DeleteConfirm": function() { return /* reexport */ DeleteConfirm/* DeleteConfirm */.y; },
  "default": function() { return /* binding */ core_Notifications; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/mosanic/styles/colors.js
var colors = __webpack_require__(2921);
// EXTERNAL MODULE: ./src/features/notification/action.js
var action = __webpack_require__(64725);
// EXTERNAL MODULE: ./src/features/notification/reducer.js
var reducer = __webpack_require__(91994);
// EXTERNAL MODULE: ./src/utils/Text.js
var Text = __webpack_require__(68311);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
// EXTERNAL MODULE: ../../node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(88932);
// EXTERNAL MODULE: ../../node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(9461);
;// CONCATENATED MODULE: ./src/mosanic/core/Notifications/Notifications.js









var Notifications = function() {
    // const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    var dispatch = (0,es/* useDispatch */.I0)();
    var notifications = (0,es/* useSelector */.v9)(reducer/* getNotificationsSelector */.S);
    var ref = (0,react.useState)([]), displayed = ref[0], setDisplayed = ref[1];
    // const removeDisplayed = useCallback((id) => {
    //     setDisplayed([...displayed.filter(key => key != id)])
    // }, [displayed])
    // const dismiss = useCallback((key) => {
    //     dispatch(dismissNotification({notificationId: key, feature: 'snackbar'}));
    //     removeDisplayed(key);
    // },[dispatch, removeDisplayed])
    (0,react.useEffect)(function() {
        if (!notifications || (notifications === null || notifications === void 0 ? void 0 : notifications.length) === 0) return undefined;
        notifications.forEach(function(notification) {
            if (!(0,Text/* isString */.HD)(notification === null || notification === void 0 ? void 0 : notification.message)) return;
            var type = (notification === null || notification === void 0 ? void 0 : notification.variant) ? notification.variant : "warning";
            react_toastify_esm/* toast */.Am[type](notification === null || notification === void 0 ? void 0 : notification.message, {
                position: notification === null || notification === void 0 ? void 0 : notification.position,
                autoClose: (notification === null || notification === void 0 ? void 0 : notification.persist) ? false : notification === null || notification === void 0 ? void 0 : notification.duration,
                // autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
            dispatch((0,action/* removeNotification */.FV)({
                notificationId: notification === null || notification === void 0 ? void 0 : notification._id,
                feature: "[auto]"
            }));
        });
        return function() {};
    }, [
        dispatch,
        notifications
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "\n        :root{\n            --toastify-color-info: ".concat(colors/* default.util.primary.base */.ZP.util.primary.base, ";\n            --toastify-color-success: ").concat(colors/* default.util.bright.green */.ZP.util.bright.green, ";\n            --toastify-color-warning: ").concat(colors/* default.util.bright.orange */.ZP.util.bright.orange, ";\n            --toastify-color-error: ").concat(colors/* default.util.bright.red */.ZP.util.bright.red, ";\n        }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                newestOnTop: false,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                draggable: true,
                pauseOnHover: true
            })
        ]
    });
};
/* harmony default export */ var Notifications_Notifications = (Notifications);

// EXTERNAL MODULE: ./src/mosanic/core/Notifications/BuilderConfirm.js
var BuilderConfirm = __webpack_require__(50659);
// EXTERNAL MODULE: ./src/mosanic/core/Notifications/DeleteConfirm.js
var DeleteConfirm = __webpack_require__(37676);
;// CONCATENATED MODULE: ./src/mosanic/core/Notifications/index.js




/* harmony default export */ var core_Notifications = (Notifications_Notifications);


/***/ }),

/***/ 9461:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);